// Safe token storage — falls back to in-memory when localStorage is
// unavailable (e.g. inside a cross-origin iframe like the Emergent preview,
// where browsers block/partition storage and setItem throws).
const KEY = "reelty_token";
let memoryToken = null;

function safeLS(op) {
  try {
    return op(window.localStorage);
  } catch {
    return undefined;
  }
}

export function getToken() {
  const v = safeLS((ls) => ls.getItem(KEY));
  if (v) return v;
  return memoryToken;
}

export function setToken(token) {
  memoryToken = token;
  safeLS((ls) => ls.setItem(KEY, token));
}

export function removeToken() {
  memoryToken = null;
  safeLS((ls) => ls.removeItem(KEY));
}

// ---- Impersonation ("View as user"): stash the admin's real token so we can
// restore it on exit. Prefer sessionStorage; fall back to memory when blocked.
const ADMIN_KEY = "reelty_admin_token";
const IMP_KEY = "reelty_impersonation";
let memAdmin = null;
let memImp = null;

function safeSS(op) {
  try {
    return op(window.sessionStorage);
  } catch {
    return undefined;
  }
}

export function startImpersonation(token, info) {
  const adminToken = getToken();
  memAdmin = adminToken;
  safeSS((ss) => ss.setItem(ADMIN_KEY, adminToken));
  memImp = JSON.stringify(info);
  safeSS((ss) => ss.setItem(IMP_KEY, memImp));
  setToken(token);
}

export function getAdminToken() {
  return safeSS((ss) => ss.getItem(ADMIN_KEY)) || memAdmin;
}

export function getImpersonation() {
  const v = safeSS((ss) => ss.getItem(IMP_KEY)) || memImp;
  try {
    return v ? JSON.parse(v) : null;
  } catch {
    return null;
  }
}

export function clearImpersonation() {
  memAdmin = null;
  memImp = null;
  safeSS((ss) => ss.removeItem(ADMIN_KEY));
  safeSS((ss) => ss.removeItem(IMP_KEY));
}
